<template>
    <div class="overflow-x-auto">
        <table
            class="min-w-full divide-y divide-theme-border bg-theme-canvas text-theme-base"
        >
            <thead>
                <tr>
                    <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                    >
                        Unidades
                    </th>
                    <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                    >
                        Horas adicionales
                    </th>
                    <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                    >
                        Costo adicional
                    </th>
                </tr>
            </thead>
            <tbody class="divide-y divide-theme-border">
                <tr
                    v-for="(item, index) in items"
                    :key="`delivery-config-${id}-${index}`"
                >
                    <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-theme-base"
                    >
                        <span>
                            {{ getRangeMessage(item, index) }}
                        </span>
                    </td>
                    <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-theme-base"
                    >
                        <span>
                            {{ item.deliveryHours }}
                        </span>
                    </td>
                    <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-theme-base"
                    >
                        <span>
                            {{ item.deliveryPrice | currency }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "DeliveryConfigurationByUnitsViewer",
    props: {
        items: {
            default: () => [],
            required: true,
            type: Array
        },
        id: {
            default: () => "id",
            required: false,
            type: String
        }
    },
    data: () => ({}),
    computed: {
        ...mapGetters("control", ["tableDark"])
    },
    methods: {
        getRangeMessage(item, index) {
            const min = item.min;
            if (index === this.items.length - 1) {
                return `Más de ${min}`;
            }
            const max = this.items.at(index + 1).min - 1;
            if (min == max) {
                return `Para ${min}`;
            }
            return `Entre ${min} - ${max}`;
        }
    }
};
</script>
